import React from 'react';
import { Button } from '@applane/react-core-components';
import { crossIconPng } from '../images';
import { View, Image } from '../app-components';
import { ROUTES } from '../Lib/constants';

const successTheme = {
  boundry: {
    width: 400,
    height: 300,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'center',
  },

  boxToHoldMessage: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '24px',
    color: 'green',
  },

  flexBoxToHoldDoneButton: {
    width: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItem: 'center',
    padding: '10px 0px',
  },

  boxToHoldCloseButton: {
    width: 'inherit',
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItem: 'center',
    padding: '5px 5px',
  },

  closeButtonProperties: {
    padding: '5px',
    color: 'red',
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  doneButtonProperties: {
    backgroundColor: 'blue',
    color: 'white',
    width: '200px',
    textAlign: 'center',
    borderRadius: '20px',
    padding: '12px 0px',
    cursor: 'pointer',
  },
};

export const SuccessMessage = (props) => {
  const { navigation } = props;

  const handleClick = () => {
    navigation.reset(ROUTES.dealerData.name);
    navigation.navigate(ROUTES.ViewDealer.name, {
      item: { _id: navigation?.state?.params?.dealerId },
    });
  };

  return (
    <View style={successTheme.boundry}>
      <View style={successTheme.boxToHoldCloseButton}>
        <Button
          style={successTheme.closeButtonProperties}
          onClick={() => handleClick()}
        >
          <Image source={crossIconPng} style={{ width: 15, height: 15 }} />
        </Button>
      </View>
      <View style={successTheme.boxToHoldMessage}>Payment Successful</View>
      <View style={successTheme.flexBoxToHoldDoneButton}>
        <View style={successTheme.flexBoxToHoldDoneButton}>
          <Button
            style={successTheme.doneButtonProperties}
            onClick={() => handleClick()}
          >
            OK
          </Button>
        </View>
      </View>
    </View>
  );
};
